export  class CardShopStruct {
    count=0
    product
}

